interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <div className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page === 1}
        className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>

      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          aria-current={item === page ? "page" : undefined}
          className={`flex h-9 w-9 items-center justify-center rounded-md text-sm transition-colors cursor-pointer ${
            item === page
              ? "bg-primary-500 text-background-50"
              : "border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {item}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page === totalPages}
        className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}